import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import {BsSearch} from 'react-icons/bs'

import EmploymentType from '../EmploymentType'
import SalaryType from '../SalaryType'
import JobItem from '../JobItem'
import ProfileJob from '../ProfileJob'
import Header from '../Header'
import './index.css'

const apiStatus = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  progress: 'PROGRESS',
  failure: 'FAILURE',
  noJob: 'NO-JOB',
}

const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]

class Jobs extends Component {
  state = {
    JobData: '',
    apiStatusView: apiStatus.initial,
    searchData: '',
    typeList: [],
    typeId: '',
    salaryData: '',
  }

  componentDidMount() {
    this.getJobItem()
  }

  renderNoJobFound = () => (
    <div className="no-job-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
        alt="no jobs"
        className="no-job-img"
      />
      <h1 className="no-job-head">No Jobs Found</h1>
      <p className="no-job-para">
        We could not find any jobs.try other filters.
      </p>
    </div>
  )

  getJobItem = async () => {
    const {searchData, typeList, salaryData} = this.state
    const joinedItems = typeList.join()
    this.setState({apiStatusView: apiStatus.progress})
    const jwtToken = Cookies.get('jwt_token')
    const apiUrl = `https://apis.ccbp.in/jobs?employment_type=${joinedItems}&search=${searchData}&minimum_package=${salaryData}`

    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }

    const response = await fetch(apiUrl, options)
    if (response.ok === true) {
      const fetchedData = await response.json()
      const {jobs, total} = fetchedData
      if (total > 0) {
        const updatedData = jobs.map(eachData => ({
          companyLogoUrl: eachData.company_logo_url,
          employmentType: eachData.employment_type,
          id: eachData.id,
          jobDescription: eachData.job_description,
          location: eachData.location,
          packagePerAnnum: eachData.package_per_annum,
          rating: eachData.rating,
          title: eachData.title,
        }))
        this.setState({JobData: updatedData, apiStatusView: apiStatus.success})
      } else {
        this.setState({
          apiStatusView: apiStatus.noJob,
        })
      }
    } else {
      this.setState({apiStatusView: apiStatus.failure})
    }
  }

  renderLoadingView = () => (
    <div className="loader-container" testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  onClickRetryButton = () => {
    this.getJobItem()
  }

  renderFailureView = () => (
    <div className="failure-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png "
        alt="failure view"
        className="failure-job-img"
      />
      <h1 className="job-head">Oops Something Went Wrong</h1>
      <p className="job-para">
        we cannot seem to find the page you are looking for.
      </p>
      <button
        type="button"
        className="retry-button"
        onClick={this.onClickRetryButton}
      >
        Retry
      </button>
    </div>
  )

  renderSuccessView = () => {
    const {JobData} = this.state
    return (
      <ul className="job-item-container-details">
        {JobData.map(eachJob => (
          <JobItem eachJob={eachJob} key={eachJob.id} />
        ))}
      </ul>
    )
  }

  renderApiStatus = () => {
    const {apiStatusView} = this.state

    switch (apiStatusView) {
      case apiStatus.progress:
        return this.renderLoadingView()

      case apiStatus.failure:
        return this.renderFailureView()
      case apiStatus.success:
        return this.renderSuccessView()
      case apiStatus.noJob:
        return this.renderNoJobFound()

      default:
        return null
    }
  }

  onSearchJob = () => {
    this.getJobItem()
  }

  onChangeJob = event => {
    this.setState({searchData: event.target.value})
  }

  onEmployType = id => {
    const {typeList} = this.state

    this.setState({typeList: [...typeList, id], typeId: id}, this.getJobItem)
  }

  onChangeSalary = id => {
    this.setState({salaryData: id}, this.getJobItem)
  }

  render() {
    const {typeId} = this.state
    return (
      <div className="job-main-container">
        <Header />

        <div className="job-container">
          <div className="filter-container">
            <div className="search-container-1">
              <button
                type="button"
                testid="searchButton"
                className="search-button"
              >
                <input
                  type="search"
                  className="input-search"
                  onChange={this.onChangeJob}
                />
                <BsSearch
                  className="search-icon"
                  color="#ffffff"
                  size="20"
                  onClick={this.onSearchJob}
                />
              </button>
            </div>
            <ProfileJob />
            <div>
              <hr className="job-hr-line" />
              <h1 className="employ-head">Type of Employment</h1>
              <ul>
                {employmentTypesList.map(eachItem => (
                  <EmploymentType
                    key={eachItem.employmentTypeId}
                    eachType={eachItem}
                    onEmployType={this.onEmployType}
                    checkType={eachItem.employmentTypeId === typeId}
                  />
                ))}
              </ul>
            </div>
            <div>
              <hr className="job-hr-line" />
              <h1 className="employ-head">Salary Range</h1>
              <ul>
                {salaryRangesList.map(eachItem => (
                  <SalaryType
                    key={eachItem.salaryRangeId}
                    eachSalary={eachItem}
                    onChangeSalary={this.onChangeSalary}
                  />
                ))}
              </ul>
            </div>
          </div>
          <div className="joby-container">
            <div className="search-container">
              <button
                type="button"
                testid="searchButton"
                className="search-button"
              >
                <input
                  type="search"
                  className="input-search"
                  onChange={this.onChangeJob}
                />
                <BsSearch
                  className="search-icon"
                  color="#ffffff"
                  size="20"
                  onClick={this.onSearchJob}
                />
              </button>
            </div>
            <div className="api-container">{this.renderApiStatus()}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Jobs
